"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
require("./Card.scss");
var SectionHeading_1 = __importDefault(require("../SectionHeading"));
var Card = function (props) {
    var _a = props.dusk, dusk = _a === void 0 ? null : _a, heading = props.heading, subHeading = props.subHeading, _b = props.children, children = _b === void 0 ? null : _b, footer = props.footer, _c = props.size, size = _c === void 0 ? 'base' : _c, inverted = props.inverted;
    return (react_1.default.createElement("div", { className: "card card--" + size + " card--" + (inverted ? 'inverted' : 'plain'), "data-dusk": dusk },
        heading && (react_1.default.createElement("div", { className: "card__heading" },
            react_1.default.createElement(SectionHeading_1.default, { heading: heading, subHeading: subHeading }))),
        react_1.default.createElement("div", { className: "card__body" }, children),
        footer && react_1.default.createElement("div", { className: "card__footer" }, footer)));
};
exports.default = Card;
//# sourceMappingURL=Card.js.map